import { ILink } from '@/interfaces/Link';

export const generateSmartLink = (link: ILink): string => {
  return link.subDomain
    ? `https://${link.subDomain}.${link.domain ?? 'linkfluencer.io'}/${link.shortUrl}`
    : `https://${link.domain ?? 'linkfluencer.io'}/${link.shortUrl}`;
};
